/* ---------------------------------------------------------------------------
   vg-lightbox.js - visualizador de fotos da pagina de produto

   31/10 - reescrito. O que havia antes abria a foto sobre um retangulo preto
   solido, sem transicao nenhuma: o preto entrava num quadro e a foto aparecia
   dentro dele. Num site de roupa isso le como erro de carregamento, nao como
   um visualizador.

   Agora:
     - o fundo e a propria pagina desfocada (vidro fosco), nao uma chapa preta;
     - a abertura e animada: o fundo entra desfocando e a foto sobe e cresce
       de 0,94 para 1 na mesma curva do resto do tema;
     - setas de verdade para passar foto, com estado desabilitado nas pontas;
     - barras no rodape mostram em que foto voce esta e levam direto a ela.

   Notas de implementacao:
     - A lista de slides e montada A CADA abertura, lida do DOM na hora. O
       vg-pdp.js reordena os filhos da galeria quando a cor muda, logo a ordem
       do DOM e sempre a ordem que o cliente esta vendo - e as setas andam
       dentro da cor escolhida, nao do catalogo inteiro.
     - A primeira imagem usa currentSrc, que o navegador ja tem em cache: o
       primeiro quadro aparece instantaneo.
     - O CSS vive em snippets/vg-pdp-style.liquid, que sai junto da secao. Se
       estivesse aqui dentro, a abertura teria um quadro sem estilo.
     - `hidden` so sai no fim da animacao de fechar. Sem isso a foto some de
       uma vez e a transicao de saida nunca chega a ser vista.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var GALLERY = '.product__gallery';
  var MAX_BARS = 10;          // acima disso as barras viram um contador
  var OPEN_MS = 460;
  var CLOSE_MS = 240;

  var overlay = null;
  var track = null;
  var ui = null;
  var closeBtn = null;
  var prevBtn = null;
  var nextBtn = null;
  var barsBox = null;
  var countEl = null;

  var bars = [];
  var count = 0;
  var current = 0;
  var lastFocus = null;
  var closeTimer = null;

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function icon(d) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true"><path d="' + d + '"/></svg>'
    );
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'vg-lb';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product photos');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="vg-lb__scrim"></div>' +
      '<div class="vg-lb__track"></div>' +
      '<div class="vg-lb__ui">' +
        '<button type="button" class="vg-lb__btn vg-lb__close" aria-label="Close">' +
          icon('M6 6l12 12M18 6L6 18') +
        '</button>' +
        '<button type="button" class="vg-lb__btn vg-lb__nav vg-lb__nav--prev" aria-label="Previous photo">' +
          icon('M15 5l-7 7 7 7') +
        '</button>' +
        '<button type="button" class="vg-lb__btn vg-lb__nav vg-lb__nav--next" aria-label="Next photo">' +
          icon('M9 5l7 7-7 7') +
        '</button>' +
        '<div class="vg-lb__bars" role="tablist" aria-label="Photos"></div>' +
        '<p class="vg-lb__count" aria-hidden="true"></p>' +
      '</div>';

    document.body.appendChild(overlay);
    track = overlay.querySelector('.vg-lb__track');
    ui = overlay.querySelector('.vg-lb__ui');
    closeBtn = overlay.querySelector('.vg-lb__close');
    prevBtn = overlay.querySelector('.vg-lb__nav--prev');
    nextBtn = overlay.querySelector('.vg-lb__nav--next');
    barsBox = overlay.querySelector('.vg-lb__bars');
    countEl = overlay.querySelector('.vg-lb__count');

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });

    overlay.querySelector('.vg-lb__scrim').addEventListener('click', close);
    track.addEventListener('scroll', onScroll, { passive: true });

    // Toque no fundo (fora da foto) fecha. O alvo so e a pista ou o slide
    // quando o dedo caiu na faixa vazia ao lado da imagem.
    track.addEventListener('click', function (e) {
      if (e.target === track || e.target.classList.contains('vg-lb__slide')) close();
    });

    window.addEventListener('resize', onResize);
    bindSwipeDown();
  }

  // Arrastar para baixo fecha, que e o gesto que todo mundo tenta primeiro.
  // A pista rola na horizontal e tem overflow-y escondido, entao o movimento
  // vertical esta livre e nao briga com a navegacao entre fotos.
  function bindSwipeDown() {
    var x0 = 0;
    var y0 = 0;
    var tracking = false;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      tracking = true;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      if (t.clientY - y0 > 90 && Math.abs(t.clientX - x0) < 50) close();
    }, { passive: true });
  }

  function imagesIn(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('img'));
  }

  function buildBars() {
    barsBox.textContent = '';
    bars = [];

    var many = count > MAX_BARS;
    barsBox.hidden = count < 2 || many;
    countEl.hidden = !many;

    if (barsBox.hidden) return;

    for (var i = 0; i < count; i += 1) {
      (function (index) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vg-lb__bar';
        b.setAttribute('aria-label', 'Photo ' + (index + 1) + ' of ' + count);
        b.addEventListener('click', function () { jump(index); });
        barsBox.appendChild(b);
        bars.push(b);
      })(i);
    }
  }

  function paint() {
    for (var i = 0; i < bars.length; i += 1) {
      bars[i].setAttribute('aria-current', i === current ? 'true' : 'false');
    }
    countEl.textContent = (current + 1) + ' / ' + count;

    var solo = count < 2;
    prevBtn.hidden = solo;
    nextBtn.hidden = solo;
    prevBtn.disabled = current === 0;
    nextBtn.disabled = current === count - 1;
  }

  function onScroll() {
    if (!track.clientWidth) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i !== current && i >= 0 && i < count) {
      current = i;
      paint();
    }
  }

  function onResize() {
    if (!overlay || overlay.hidden) return;
    track.scrollLeft = current * track.clientWidth;
  }

  function jump(i) {
    i = Math.max(0, Math.min(i, count - 1));
    var left = i * track.clientWidth;
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: left, behavior: reduceMotion() ? 'auto' : 'smooth' });
    } else {
      track.scrollLeft = left;
    }
  }

  function go(step) {
    jump(current + step);
  }

  function open(gallery, index) {
    var imgs = imagesIn(gallery);
    if (!imgs.length) return;
    if (!overlay) build();

    clearTimeout(closeTimer);

    track.textContent = '';
    imgs.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'vg-lb__slide';

      var big = document.createElement('img');
      // currentSrc = exatamente o arquivo que o navegador ja baixou.
      big.src = img.currentSrc || img.src;
      if (img.srcset) {
        big.srcset = img.srcset;
        big.sizes = '100vw';
      }
      big.alt = img.alt || '';
      big.decoding = 'async';
      big.draggable = false;

      slide.appendChild(big);
      track.appendChild(slide);
    });

    count = imgs.length;
    current = Math.max(0, Math.min(index, count - 1));
    lastFocus = document.activeElement;

    // Esconder a barra de rolagem da pagina encolhe o conteudo e a pagina
    // inteira pula para o lado atras do vidro. Repoe a largura exata dela.
    var gutter = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--vg-lb-gutter', gutter + 'px');

    overlay.hidden = false;
    document.documentElement.classList.add('vg-lb-open');

    buildBars();

    // scrollLeft so vale depois que a pista tem largura, ou seja depois de
    // sair do hidden. A leitura de clientWidth forca o layout.
    track.scrollLeft = current * track.clientWidth;
    paint();

    // A classe que dispara a animacao precisa entrar num quadro DEPOIS do
    // estado inicial ter sido calculado. No mesmo quadro o navegador junta
    // os dois valores e nao ha transicao nenhuma.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (overlay) overlay.classList.add('is-open');
      });
    });

    closeBtn.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!overlay || overlay.hidden) return;

    overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);

    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      overlay.hidden = true;
      document.documentElement.classList.remove('vg-lb-open');
      document.documentElement.style.removeProperty('--vg-lb-gutter');
      // Solta as imagens grandes: sem isso ficam seis fotos de tela cheia
      // decodificadas na memoria depois de fechar.
      track.textContent = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }, reduceMotion() ? 0 : CLOSE_MS);
  }

  function focusables() {
    return Array.prototype.filter.call(
      overlay.querySelectorAll('button:not([disabled])'),
      function (el) { return !el.hidden && el.offsetParent !== null; }
    );
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      go(1);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      go(-1);
    } else if (e.key === 'Tab') {
      var items = focusables();
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (items.indexOf(document.activeElement) === -1) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // Delegacao no documento: a galeria e remontada pela Section Rendering API
  // quando a variante muda, e um listener por imagem morreria nessa troca.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (overlay && !overlay.hidden) return;

    var img = e.target.closest(GALLERY + ' img');
    if (!img) return;

    var gallery = img.closest(GALLERY);
    if (!gallery) return;

    e.preventDefault();
    open(gallery, imagesIn(gallery).indexOf(img));

    // O initGalleryZoom() do theme.js continua alternando .is-zoomed no mesmo
    // clique. Nada estiliza essa classe desde 18/10, entao ela e inofensiva -
    // mas e limpo nao deixar estado pendurado na imagem.
    requestAnimationFrame(function () {
      img.classList.remove('is-zoomed');
    });
  });
})();
